import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@telus-uds/components-web';
import { useHistory } from 'react-router-dom';
import EN from '../../EN.json';
import FR from '../../FR.json';
import { useLocaleContext } from '../context/LocaleContext';

const RegistrationModel = ({ show = false, labels }) => {
  const [showModal, setShowModal] = useState(show);
  const local = useLocaleContext();
  const {
    confirmationDialog1: { emailConfirmation, confirmationMessage, close }
  } = local === 'en-US' ? EN : FR;
  const history = useHistory();
  const closeModal = () => {
    setShowModal(false);
    history.push(`/login`);
  };
  const proceed = () => {
    setShowModal(false);
    history.push(`/login`);
  };

  return (
    <div>
      <Modal
        heading={emailConfirmation}
        bodyText={confirmationMessage}
        // confirmButtonText={close}
        onConfirm={proceed}
        onClose={closeModal}
        isOpen={showModal}
      />
    </div>
  );
};

RegistrationModel.propTypes = {
  show: PropTypes.bool,
  labels: PropTypes.shape({
    emailConfirmation: PropTypes.string,
    confirmationMessage: PropTypes.string,
    close: PropTypes.string
  }).isRequired
};

export default RegistrationModel;
